import { ssrRef, computed } from "@nuxtjs/composition-api";

// Holds the linkingToken + profile returned by oauthLogin, used to complete
// either oauthRegister (new user) or linkOauthProvider (existing password user).
// The linkingToken is valid ~10 minutes.
// ssrRef (not ref) so this state is request-scoped on the server; a plain
// module-level ref would be shared across all SSR requests on the process.
const linkingToken = ssrRef(null, "oauth-linkingToken");
const profile = ssrRef(null, "oauth-profile");
const needsLinking = ssrRef(false, "oauth-needsLinking");

const hasProfile = computed(() => !!profile.value);

function setOAuthData(token, profileData) {
  linkingToken.value = token;
  profile.value = profileData;
}

function setLinkingRequired() {
  needsLinking.value = true;
}

function clear() {
  linkingToken.value = null;
  profile.value = null;
  needsLinking.value = false;
}

export function useOAuthStore() {
  return {
    linkingToken,
    profile,
    needsLinking,
    hasProfile,
    setOAuthData,
    setLinkingRequired,
    clear,
  };
}
